//
//
//
//
//
//
//
//
//
//

export default {
  name: "NsProductDetailInfo",
  props: {
    /**
     * Title of the section content
     */
    title: {
      type: String,
      default: ""
    },
    /**
     * HTML content of the section
     */
    content: {
      type: String,
      default: ""
    },
    /**
     * Enum type of content to aid in styling the section
     * "videos", "benefits", "usage", "ingredients", "resources"
     */
    contentType: {
      type: String,
      default: ""
    }
  }
};
